<template>
  <div id="app">
    <div class="loading" v-if="isLoading">
      <img src="https://www.3dreal.com/assets/3dreal-loading.gif" />
    </div>
    <div class="bf-logo">
      <a href="https://www.3dreal.com/" target="_blank">
        <img src="https://www.3dreal.com/assets/3dreal-logo-blue@2x.png" />
      </a>
    </div>
    <div id="panorama"></div>
    <modal
      :title="title"
      :is-show="show"
      :show-ok="false"
      :show-footer="false"
      transition="fadeDown"
      @close="show = false"
    >
      <div style="height:100%">
        <iframe style="width: 100%;height:100%" :src="iframeSrc" />
      </div>
    </modal>
    <music-con />
  </div>
</template>
<script>
import musicCon from "@/components/music-con";
export default {
  name: "App",
  components: {
    musicCon
  },
  data() {
    return {
      show: false,
      title: "",
      iframeSrc: "",
      isLoading: true
    };
  },
  mounted() {
    // eslint-disable-next-line no-undef
    let viewer = pannellum.viewer("panorama", {
      //Pannellum支持四种处理全景图片的方式：equirectangular,partial,cubic,multi-resolution
      allow_user_interactions: false,
      hotSpotDebug:false,
      firstScene: "circle", //首次加载那个图片
      sceneFadeDuration: 1000, //全景图场景切换时的持续时间
      autoLoad: true, //自动加载
      panorama: "https://pannellum.org/images/tocopilla.jpg",
      showControls: false, //是否显示控制按钮，默认true；
      autoRotate: -2, //是否自动旋转，在加载之后，全景图会水平旋转显示，负数为往右边旋转，整数为往左边旋转，值为数字类型；
      //场景，值为对象，其属性名代表着场景的id（sceneId），属性值为viewer的配置参数，其参数会覆盖默认（上述中的default对象）设置的参数；
      pitch: -29,
      yaw: -151,
      hfov: 100.0,
      type: "multires",
      multiRes: {
        basePath: "./image/img2",
        path: "/%l/%s%y_%x",
        fallbackPath: "/fallback/%s",
        extension: "jpg",
        tileResolution: 256,
        maxLevel: 4,
        cubeResolution: 2048
      },
      hotSpots: [
        //热点，以全景为坐标系的固定点，可以设置链接跳转和点击事件，也可以跳转到不同的场景，该属性的值为对象
        {
          pitch: -5.254943554243,
          yaw: 81.31114874435126,
          type: "info",
          cssClass: "shou1",
          text: "隔层双肩带单肩水桶包人民币¥1299.00",
          clickHandlerFunc: () => {
            this.iframeSrc =
              "https://mobileshop.3dreal.com/1215447669864263682/home/detail?id=1334726512516390913";
            this.show = true;
            this.title = "隔层双肩带单肩水桶包";
          }
        },
        // {
        //   pitch: -2.254943554243,
        //   yaw: 7.31114874435126,
        //   type: "info",
        //   cssClass: "shou1",
        //   text: "伊斯兰女长裙¥1999.00",
        //   URL:
        //     "http://1215156752334843906.mobileshop.3dreal.com/dashboard/home/detail?id=1262366152048590849"
        // },
        {
          pitch: -32.254943554243,
          yaw: 158.31114874435126,
          type: "info",
          cssClass: "shou1",
          text: "法式高跟鞋女细跟2020款夏季百搭¥1999.00",
          clickHandlerFunc: () => {
            this.iframeSrc =
              "https://www.3dreal.com/audit?id=871&type=1&sign=c446bce065a5ffc75d92389727faccd7";
            this.show = true;
            this.title = "法式高跟鞋女细跟2020款夏季百搭";
          }
        },
        {
          pitch: -16.038349112976878,
          yaw: -141.93480712161175,
          type: "info",
          cssClass: "shou1",
          text: "2020夏季新款收腰清凉短袖连衣裙¥1599.00",
          clickHandlerFunc: () => {
            this.iframeSrc =
              "https://www.3dreal.com/audit?id=880&type=1&sign=6e9ce13db070d74c06a9226345ecb7e8";
            this.show = true;
            this.title = "2020夏季新款收腰清凉短袖连衣裙";
          }
        },
        {
          pitch: 0.6210766442133998,
          yaw: -165.7100349456342,
          type: "info",
          cssClass: "shou1",
          text: "长款祺旗袍2020新款年轻款中国风优雅¥1999.00",
          clickHandlerFunc: () => {
            this.iframeSrc =
              "https://www.3dreal.com/audit?id=549&type=1&sign=793e23f86a074f44f930b3d20199f732";
            this.show = true;
            this.title = "长款祺旗袍2020新款年轻款中国风优雅";
          }
        },
        {
          pitch: -9.876415059535173,
          yaw: -131.23672719492265,
          type: "info",
          cssClass: "shou1",
          text: "2020夏季新款短袖T恤纯色清凉¥999.00",
          clickHandlerFunc: () => {
            this.iframeSrc =
              "https://mobileshop.3dreal.com/1215447669864263682/home/detail?id=1334745225147834370";
            this.show = true;
            this.title = "2020夏季新款短袖T恤纯色薄清凉";
          }
        },
        {
          pitch: -38, //定位参数， 单位：角度
          yaw: -88, //定位参数， 单位：角度 y轴，空间中的纵轴
          type: "info", //热点类型，scene 场景切换热点； info 信息展示；URL 以热点为链接，跳转到其他页面的`url
          text: "进入潮鞋馆",
          cssClass: "arrow",
          URL: window.location.origin + "/shoes"
        },
        {
          pitch: 3, //定位参数， 单位：角度
          yaw: 173, //定位参数， 单位：角度 y轴，空间中的纵轴
          type: "info", //热点类型，scene 场景切换热点； info 信息展示；URL 以热点为链接，跳转到其他页面的`url
          text: "了解更多",
          cssClass: "shou1",
          URL: 'https://www.3dreal.com/'
        }
      ]
    });
    window.addEventListener("load", () => {
      setTimeout(() => {
        this.isLoading = false;
        var ele = document.querySelectorAll('.shou1')
          console.log(ele);
      }, 1000);
    });
    console.log(viewer);
  },
  methods: {
  }
};
</script>
<style>
.pnlm-ui .pnlm-about-msg {
  display: none !important;
}

.pnlm-ui .pnlm-orientation-button {
  display: none !important;
}
.pnlm-lmsg {
  display: none;
}
</style>
<style lang="less">
body {
  margin: 0;
  padding: 0;
}
#app {
  .bf-logo {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1;
    img{
      height: 50px;
      width: 100%;
    }
    @media (max-width: 768px) {
      img{
        height: 30px;
        width: 100%;
      }
    }

  }
}
#panorama {
  height: 100vh;
}
.shou1 {
  background-image: url("../../assets/image/10.png");
  width: 50px;
  height: 50px;
  background-size: 50px 300px;
  animation: show1 0.3s infinite step-start;
}
@keyframes show1 {
  0% {
    background-position: 0 0;
  }
  25% {
    background-position: 0 -250px;
  }
  50% {
    background-position: 0 -150px;
  }
  75% {
    background-position: 0 -150px;
  }
  100% {
    background-position: 0 0;
  }
}
.arrow {
  background-image: url("../../assets/image/arrow.png");
  width: 64px;
  height: 64px;
  background-size: 64px 1600px;
  animation: arrow 0.8s infinite step-start;
}
@keyframes arrow {
  0% {
    margin-top: 0;
  }
  25% {
    margin-top: -5px;
  }
  50% {
    margin-top: -10px;
  }
  75% {
    margin-top: -15px;
  }
  100% {
    margin-top: -20px;
  }
}
.loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  z-index: 100;
  background-color: #fff;
  img {
    width: 22%;
    height: auto;
  }
}
</style>
